import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Typography } from '@comparethemarketau/manor-typography';

import { ProviderLogo } from '../common/provider_logo';
import { withQuoteFlatten } from '../common/with_quote_flatten';
import { ProductUnderwritten } from '../common/product_underwritten';

const useStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        marginBottom: theme.spacing[12]
    },
    product: {

    },
    logo: {
        marginRight: theme.spacing[24]
    },
    productName: {
        fontSize: theme.fontSize.xl,
        lineHeight: theme.lineHeight.normal,
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.primary800
    },
    productUnderwritten: {
        fontSize: theme.fontSize.sm,
        lineHeight: theme.lineHeight.normal,
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey700
    }
}));

// eslint-disable-next-line valid-jsdoc
/**
 * Layout:
 * | -----------  | Product-name          |
 * | Provier-logo | Provider-underwritten |
 * | ___________  |       breakline       |
 */
const _ProductSummary = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { className, providerCode, productName, productUnderwriterName } = props;

    return (
        <div className={classNames('test-policyProductCard-summary', className, classes.container)}>
            <ProviderLogo className={classes.logo} code={providerCode} />
            <div className={classes.product}>
                <Typography className={classes.productName}>{productName}</Typography>
                <ProductUnderwritten className={classes.productUnderwritten} productUnderwriterName={productUnderwriterName} />
            </div>
        </div>
    );
};

_ProductSummary.propTypes = {
    className: PropTypes.string,
    quote: PropTypes.object,

    productName: PropTypes.string,
    productUnderwriterName: PropTypes.string,
    providerCode: PropTypes.string.isRequired
};

const ProductSummary = withQuoteFlatten(_ProductSummary);

export { ProductSummary };
